import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3284dcfe"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=3284dcfe&prod&lang=scss"
import style1 from "./edit.vue?vue&type=style&index=1&id=3284dcfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports